import { render } from "./myfooter.vue?vue&type=template&id=f5505fde&scoped=true"
const script = {}

import "./myfooter.vue?vue&type=style&index=0&id=f5505fde&scoped=true&lang=scss"

import exportComponent from "/Users/maedadesign3/Dropbox (個人用)/MaedaDesign/maedadesignllc/mdllc/server/mdllc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5505fde"]])

export default __exports__